import React, { Component } from "react";
import clsx from "clsx";

import "./agent-run-request-field.css";

const PLACEHOLDER_WITHOUT_EXAMPLE = "Say what you want done for this client.";

class AgentRunRequestField extends Component {
	onTextChanged = event => {
		this.props.onChange(event.target.value);
	};

	render() {
		const { value, example, isAutoFocused, isCompact, disabled } = this.props;
		const placeholder = example ? `e.g. ${example}` : PLACEHOLDER_WITHOUT_EXAMPLE;

		return (
			<div className={clsx("tk-form-field", "agent-run-request", isCompact && "agent-run-request--compact")}>
				<div className="tk-form-label">
					What do you want?<span className="tk-form-required">*</span>
				</div>
				<textarea
					className="tk-input agent-run-request__text"
					rows={isCompact ? 3 : 5}
					value={value}
					onChange={this.onTextChanged}
					placeholder={placeholder}
					maxLength={4000}
					autoFocus={!!isAutoFocused}
					disabled={!!disabled}
				/>
				<div className="tk-form-help">The agent works from this for this client. Say it the way you would to a colleague.</div>
			</div>
		);
	}
}

export default AgentRunRequestField;
